import {
  WALLET_SEARCH,
  WALLET_RESET_SEARCH,
  WALLET_COUNT_TOTAL,
  WALLET_LIST_FETCH,
  WALLET_LIST_FETCH_SUCCESS,
  WALLET_DETAIL_CLEAR,
  WALLET_DETAIL_FETCH,
  WALLET_DETAIL_FETCH_SUCCESS,
  WALLET_LIST_PROFILE_FETCH,
  WALLET_TRANSACTION_LIST_FETCH,
} from "./types";

export const walletSearch = (payload) => {
  return {
    type: WALLET_SEARCH,
    payload: payload,
  };
};

export const walletResetSearch = () => {
  return {
    type: WALLET_RESET_SEARCH,
  };
};

export const walletCountTotal = (payload) => {
  return {
    type: WALLET_COUNT_TOTAL,
    payload: payload,
  };
};

export const walletListFetch = (payload = "") => {
  return {
    type: WALLET_LIST_FETCH,
    payload: payload,
  };
};

export const walletListProfileFetch = (payload = "") => {
  return {
    type: WALLET_LIST_PROFILE_FETCH,
    payload: payload,
  };
};

export const walletTransactionListFetch = (payload = "") => {
  return {
    type: WALLET_TRANSACTION_LIST_FETCH,
    payload: payload,
  };
};

export const walletListFetchSuccess = (payload) => {
  return {
    type: WALLET_LIST_FETCH_SUCCESS,
    payload: payload,
  };
};

export const walletDetailClear = () => {
  return {
    type: WALLET_DETAIL_CLEAR,
  };
};

export const walletDetailFetch = (payload) => {
  return {
    type: WALLET_DETAIL_FETCH,
    payload: payload,
  };
};

export const walletDetailFetchSuccess = (payload) => {
  return {
    type: WALLET_DETAIL_FETCH_SUCCESS,
    payload: payload,
  };
};
